import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';

import environmentVariableReducer from '../components/environmentVariable/EnvironmentVariable.reducers';
import alertReducer from '../components/alert/Alert.reducers';
import tipoDocumentosReducer from '../components/tipoDocumentos/TipoDocumentos.reducers';
import gruposAtoReducer from '../components/gruposAto/GruposAto.reducers';
import naturezasAtoReducer from '../components/naturezasAto/NaturezasAto.reducers';
import publicarAtoReducer from '../components/publicarAto/PublicarAto.reducers';
import cardHistoricoAtosReducer from '../components/cardHistoricoAtos/CardHistoricoAtos.reducers';
import cancelarAtoReducer from '../components/cancelarAto/CancelarAto.reducers';
import editarAtoReducer from '../components/editarAto/EditarAto.reducers';

export const rootReducer = combineReducers({
  environmentVariableReducer,
  alertReducer,
  tipoDocumentosReducer,
  gruposAtoReducer,
  naturezasAtoReducer,
  publicarAtoReducer,
  cardHistoricoAtosReducer,
  cancelarAtoReducer,
  editarAtoReducer,
  router: routerReducer,
});

export default rootReducer;
